

export class AANode {
    id = "";
    name = "";
    type = "";
    description = "XXX";
    shortDescription = "";
    user:boolean = false;
    thirdPartyCompany:boolean = false;
    bankAccount:boolean = false;
    thirdParty:string = null
    disabled = false;
    lettering:boolean = false;
    detailedCarryForward: boolean = false;
    vatRate: number = null;
    vatType: string = null;
    vatOperationType: string = null;
    parent: AANode = null;
    children:AANode[] = [];
    transactionType: string = null;
    default: boolean = null;
    propagation: any = null;
    paidAndUncashed: boolean = null;
    publish: boolean = false;

    constructor(
        name,
        id,
        description,
        shortDescription,
        disabled, lettering:boolean,
        detailedCarryForward:boolean,
        vatRate:number,
        vatType:string,
        vatOperationType:string,
        type, user:boolean,
        bankAccount:boolean,
        thirdPartyCompany:boolean,
        transactionType:string,
        defaultT:boolean,
        paidAndUncashed:boolean,
        publish:boolean,
    ) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.disabled = disabled;
        this.lettering = lettering;
        this.detailedCarryForward = detailedCarryForward;
        this.vatRate = vatRate;
        this.vatType = vatType;
        this.vatOperationType = vatOperationType;
        this.description = description;
        this.shortDescription = shortDescription;
        this.parent = null;
        this.children = [];
        this.user = user;
        this.bankAccount = bankAccount;
        this.thirdPartyCompany = thirdPartyCompany;
        this.transactionType = transactionType;
        this.default = defaultT;
        this.paidAndUncashed = paidAndUncashed;
        this.publish = publish;
        this.updateThirdParty()
    }

    get displayDescription() {
        return this.name + " - " + this.description
    }

    get isAA() {
        return this.name.length >= 0;
    }

    get hasId() {
        return this.id.length > 0;
    }

    get isParent() {
        return !!this.children.length;
    }

    get digit() {
        return this.name[0]
    }

    get isLeaf() {
        return !this.name.match(/.*\s.*/)
    }

    addChild(child) {
        child.parent = this;
        this.children.push(child);
    }

    findNodeByName(aaName):AANode {
        if (this.name === aaName) {
            return this;
        }
        for (const child of this.children) {
            const foundNode = child.findNodeByName(aaName);
            if (foundNode) {
                return foundNode;
            }
        }
        return null;
    }

    setData(accountableAccount:AANode) {
        this.description = accountableAccount.description
        this.shortDescription = accountableAccount.shortDescription
        this.lettering = accountableAccount.lettering
        this.detailedCarryForward = accountableAccount.detailedCarryForward
        this.vatRate = accountableAccount.vatRate
        this.vatType = accountableAccount.vatType
        this.vatOperationType = accountableAccount.vatOperationType
        this.bankAccount =  accountableAccount.bankAccount
        this.user = accountableAccount.user
        this.thirdPartyCompany = accountableAccount.thirdPartyCompany
        this.propagation = accountableAccount.propagation
        this.transactionType = accountableAccount.transactionType
        this.default = accountableAccount.default
        this.paidAndUncashed = accountableAccount.paidAndUncashed
        this.publish = accountableAccount.publish
        this.updateThirdParty()
    }

    updateThirdParty() {
        this.thirdParty = ['user','bankAccount','thirdPartyCompany'].find(
            (attribute) => this[attribute]
        );
    }


    onThirdPartyChanged() {
        this.user = false
        this.bankAccount = false
        this.thirdPartyCompany = false
        if(this.thirdParty !== null) {
            this[this.thirdParty] = true
        }
    }
}
